<template>
    <div id="pagos-header">
        <div id="sig-container" class="full form-horizontal">
                <div class="widget">
                    <div class="widget-content widget-content-mini themed-background-info text-light-op"> <span class="float-right text-muted"><i class="fa fa-check"></i></span>Cargue de presupuestos</div>
                    <div class="widget-content border-bottom themed-background-muted text-center">
                        <span class="muted-color">Por medio de este modulo se podra cargar el presupuesto a los asesores del Contact Center FGA.</span>
                        <hr>
                        <div class="row">
                            <div class="loader" v-if="loading"><i class="fa fa-spinner fa-2x fa-spin text-info"></i></div>
                            <div class="col-md-6">
                                <div class="row centrar">
                                    <a v-on:click="listarUsuarios()">
                                        <label class="btn btn-default">
                                            <i class="fa fa-file-excel-o"></i>
                                            Lista de asesores
                                        </label>
                                    </a>
                                </div>
                                <div class="row centrar">
                                    <p>
                                        Por medio de esta opción podras descargar la lista de asesores del contact center en caso de que no estes seguro de sus identificadores.
                                    </p>
                                </div>
                            </div>
                            <div align="center" class="col-md-6">
                                <div class="row centrar">
                                    <label class="btn btn-primary">
                                        <i class="fa fa-file-excel-o"></i>
                                        <input v-on:change="importarPresupuesto()" id="archivo" ref="archivo" name="archivo" type="file"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv"
                                            style="display: none;">
                                        Seleccionar archivo
                                    </label>
                                    &nbsp;
                                    <a :href="'../files/presupuesto.xlsx'" download>
                                        <label class="btn btn-success">
                                            <i class="fa fa-file-excel-o"></i>
                                            Descargar archivo
                                        </label>
                                    </a>
                                </div>
                                <div class="row centrar">
                                    <p>
                                        Si tienes el formato listo para el cargue de presupuestos, podrás montarlo por medio del boton "Seleccionar archivo". En caso, contrario podras descargar el formato base para montar este cargue por medio de "Descargar archivo".
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>


</template>
<script>
    import {mapGetters} from 'vuex'
     import FileSaver from 'file-saver';
     import XLSX from 'xlsx';
    
    export default {
        data () {
            return {

            }
        },
        components: {

        },
        computed: {
            ...mapGetters({'loading': 'presupuesto/loading'}),
        },
        methods: {
            listarUsuarios() {
                this.$store.commit('presupuesto/setLoading', true);
                this.$store.dispatch('presupuesto/listaUsuarios')
                .then((data) => {
                    this.$store.commit('presupuesto/setLoading', false);
                    FileSaver.saveAs(data.data, 'lista_asesores.xlsx');
                    this.$notify({
                        title: 'Archivo descargado',
                        content:'El archivo fue descargado satisfactoriamente.',
                        type: 'success'
                    });
                }).catch((error) => {
                    this.$store.commit('presupuesto/setLoading', false);
                    this.$notify({
                        title: 'Fallo al descargar',
                        content:'Se produjo un error al tratar de descargar el archivo, por favor inténtelo mas tarde.'+error,
                        type: 'danger'
                    });
                });
            },
            importarPresupuesto() {
                this.file = this.$refs.archivo.files[0];
                let formData = new FormData();
                formData.append('datos', this.file);

                this.$store.commit('presupuesto/setLoading', true);
                this.$store.dispatch('presupuesto/importarPresupuesto', formData)
                .then(() => {  
                    this.$store.commit('presupuesto/setLoading', false);
                    this.$notify({
                        title: 'Archivo procesado',
                        content:'Se ha importado con exito el archivo de presupuesto.',
                        type: 'success'
                    });
                }).catch(() => {
                    this.$store.commit('presupuesto/setLoading', false);
                    this.$notify({
                        title: 'Fallo al importar',
                        content:'Se produjo un error al tratar de importar el archivo, por favor inténtelo mas tarde.'+error,
                        type: 'danger'
                    });
                });
            },
            descargarConsulta() {
                var d = new Date();
                var twoDigitMonth = d.getMonth().length + 1 === 1 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1);
                var twoDigitDate = d.getDate() + "";
                if (twoDigitDate.length == 1) twoDigitDate = "0" + twoDigitDate;
                var date = d.getFullYear() + '_' + twoDigitMonth + '_' + twoDigitDate + '_' + d.getHours() + "_" + d.getMinutes() + "_" + d.getSeconds();
                var elt = document.getElementById('general-table');
                var wb = XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });

                return XLSX.writeFile(wb, 'log_' + 'lista_campana' + '_' + date + '_.xlsx');
            },
        },
        mounted() {

        }
    }
</script>
<style>
 .disponibles {
    display: flow-root !important;
 }
 .titulos-disponible {
    padding-left: initial !important;
    padding-right: initial !important;
 }
    .muted-color {
        color: #b9b9b9;
        font-style: italic;
    }

    .centrar {
        display: block;
    }
</style>
